import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleLayout from "@/components/feature/ArticleLayout";
import PageMeta from "@/components/base/PageMeta";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfansspreadsheet.help";
const articlePath = "/artykul/jak-uzywac-usfansspreadsheet";
const articleTitle = "Jak używać USFansSpreadsheet – praktyczny poradnik";
const articleDesc = "Praktyczny poradnik używania USFansSpreadsheet – od nawigacji po zaawansowane formuły. Sprawdzone metody, które pomogą Ci pracować szybciej i efektywniej.";

const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": articleTitle,
  "description": articleDesc,
  "author": { "@type": "Person", "name": "Anna Kowalska", "jobTitle": "Specjalista SEO" },
  "datePublished": "2026-06-05",
  "dateModified": "2026-06-24",
  "publisher": { "@type": "Organization", "name": "USFansSpreadsheet.help", "url": siteUrl },
  "mainEntityOfPage": { "@type": "WebPage", "@id": `${siteUrl}${articlePath}` },
  "inLanguage": "pl-PL"
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Strona główna", "item": siteUrl },
    { "@type": "ListItem", "position": 2, "name": "Artykuły", "item": `${siteUrl}/artykul/przewodnik-usfansspreadsheet` },
    { "@type": "ListItem", "position": 3, "name": "Poradnik" }
  ]
};

const relatedArticles = [
  { title: "Kompletny przewodnik po USFansSpreadsheet", to: "/artykul/przewodnik-usfansspreadsheet" },
  { title: "USFansSpreadsheet dla początkujących", to: "/artykul/dla-poczatkujacych" },
  { title: "10 praktycznych wskazówek", to: "/artykul/wskazowki-usfansspreadsheet" },
];

export default function ArticleHowto() {
  return (
    <>
      <PageMeta
        title={articleTitle}
        description={articleDesc}
        keywords="USFansSpreadsheet, jak używać, poradnik, praktyczne wskazówki, formuły, nawigacja, Polska"
        canonicalPath={articlePath}
        ogType="article"
      />
      <JsonLd data={articleSchema} />
      <JsonLd data={breadcrumbSchema} />

      <Navbar />
      <ArticleLayout
        title="Jak używać USFansSpreadsheet – praktyczny poradnik"
        category="Poradnik"
        heroImg="https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20typing%20on%20laptop%20with%20spreadsheet%20visible%20on%20screen%2C%20warm%20cream%20desk%20surface%2C%20soft%20natural%20light%20from%20window%2C%20focused%20productive%20work%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20authentic%20working%20moment&width=1400&height=600&seq=art-howto-hero-v2&orientation=landscape"
        heroImgAlt="Jak używać USFansSpreadsheet"
        relatedArticles={relatedArticles}
      >
        <p className="text-lg md:text-xl text-foreground-800 font-medium leading-relaxed">
          Efektywne korzystanie z <strong>USFansSpreadsheet</strong> wymaga poznania kilku kluczowych technik. W tym poradniku dzielimy się sprawdzonymi metodami, które pomogą Ci pracować szybciej i wydajniej.
        </p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Podstawy nawigacji w USFansSpreadsheet</h2>
        <p>Interfejs <strong>USFansSpreadsheet</strong> został zaprojektowany tak, aby najważniejsze funkcje były zawsze pod ręką. Pasek narzędzi u góry ekranu zawiera wszystkie niezbędne opcje formatowania, a menu boczne umożliwia szybki dostęp do arkuszy i szablonów.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Efektywne formuły i automatyzacja</h2>
        <p><strong>USFansSpreadsheet</strong> obsługuje zaawansowane formuły, które automatyzują obliczenia i oszczędzają czas. Warto poznać funkcje takie jak VLOOKUP, SUMIFS i QUERY, które znacząco usprawniają analizę danych. Platforma oferuje również podpowiedzi przy wpisywaniu formuł, co ułatwia naukę.</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 pt-4">Wskazówki dla zaawansowanych</h2>
        <p>Dla zaawansowanych użytkowników <strong>USFansSpreadsheet</strong> oferuje możliwość tworzenia własnych makr i skryptów. Dzięki temu możesz zautomatyzować powtarzalne zadania i dostosować platformę do swoich unikalnych potrzeb.</p>
      </ArticleLayout>
      <Footer />
    </>
  );
}